import { inject, injectable } from 'inversify';
import ReviewsService from '../../data/service/ReviewsService';

type GetPendingReviewUseCaseProps = {
  accessToken: string;
};

@injectable()
class GetPendingReviewUseCase {
  @inject(ReviewsService) private reviewsService!: ReviewsService;

  async execute({ accessToken }: GetPendingReviewUseCaseProps) {
    const response = await this.reviewsService.getPendingReview({
      accessToken,
    });

    return response.data.data;
  }
}

export default GetPendingReviewUseCase;
